// extracted by mini-css-extract-plugin
export default {"titleText":"Title_titleText__xW-Pv"};